import { styled } from '@mui/material/styles';
import { GridActionsCellItem, GridActionsCellItemProps } from '@mui/x-data-grid-pro';

export const GridActionButton = styled((props: GridActionsCellItemProps) => <GridActionsCellItem {...props} />)(({ theme }) => ({
  color: theme.palette.text.disabled,
  '&:hover': {
    color: theme.palette.primary[theme.palette.mode],
  },
}));
